"use strict";var e=require("./components/Tabs.js"),t=require("./components/Tab.js"),s=require("./components/TabButton.js");exports.Tabs=e.default,exports.Tab=t.default,exports.TabButton=s.default;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/tabs/cjs/index.js
// module id = 378
// module chunks = 0